import type React from 'react';
import { Link } from 'react-router-dom';

export interface HealthOverviewCellLinkProps {
    to: string;
    ariaLabel: string;
    /** Drives the `data-health-overview` hook the health cells are queried by. */
    state: 'no-data' | 'alert' | 'ok';
    className?: string;
    children: React.ReactNode;
}

/**
 * The health cells all render the same shape: a link into a health page, an
 * icon, and a tooltip. The cells wrap it in `Tooltip`, which portals the bubble
 * into `document.body`, so it neither adds scrollable overflow to the table's
 * scroll container nor gets clipped by it, and Popper picks the side that fits:
 * no row-index heuristic needed.
 */
export function HealthOverviewCellLink(props: HealthOverviewCellLinkProps) {
    const { to, ariaLabel, state, className, children } = props;

    return (
        <Link to={to} aria-label={ariaLabel} data-health-overview={state} className={className}>
            {children}
        </Link>
    );
}
